var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.timer > 0)?_c('div',{staticClass:"gift-timer"},[_c('div',{staticClass:"gift-timer__timer"},[_vm._v(_vm._s(_vm.formattedTime))]),_c('div',{staticClass:"gift-timer__desc"},[_vm._v("Скидка при первой покупке")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }